// CarFinance Component Constants

export const FINANCE_CONSTANTS = {
  MONTHS: 12,
  INITIAL_DURATION: 7,
  MIN_TENURE: 2,
  MAX_TENURE: 7,
  MIN_INTEREST_RATE: 6.4,
  MAX_INTEREST_RATE: 20,
  MIN_DOWN_PAYMENT_PERCENTAGE: 0.1,
  MAX_DOWN_PAYMENT_PERCENTAGE: 0.8,
  DEFAULT_DOWN_PAYMENT_PERCENTAGE: 0.2,
  HYPOTHECATION_CHARGES: 1500,
  TENURE_OPTIONS: [1, 2, 3, 4, 5, 6, 7],
  YEAR: "year",
  YEARS: "years",
} as const;

export const MODAL_TYPES = {
  DOWNPAYMENT: 'downpayment',
  TENURE: 'tenure',
  INTEREST: 'interest',
} as const;

export const SLIDER_CONFIG = {
  MIN: 2,
  MAX: 7,
  THUMB_SIZE: 24,
  TRACK_HEIGHT: 6,
} as const;



export const VALIDATION_MESSAGES = {
  INVALID_AMOUNT: 'Please enter a valid amount',
  INVALID_NUMBER: 'Please enter a valid number',
  INVALID_FORMAT: 'Invalid input format',
  INVALID_DECIMAL: 'Invalid decimal format',
  MAX_DECIMAL_PLACES: 'Maximum 2 decimal places allowed',
  COMPLETE_DECIMAL: 'Please complete the decimal value',
  MIN_INTEREST: 'Minimum interest rate possible is 6.4%',
  MAX_INTEREST: 'Maximum interest rate possible is 20%',
  ENTER_INTEREST: 'Please enter an interest rate',
  DOWNPAYMENT_EXCEEDS_CAR_VALUE: 'Down payment cannot exceed the car value',
} as const;

export const STORAGE_KEYS = {
  LOGIN_TYPE: 'loginType',
  MMV_DATA: 'MMV',
} as const;

export const EVENT_TRACKING = {
  ACTION_TYPE: 'tap_btn',
  ACTION_NAME: 'tap_btn_emi',
} as const;

// Modal configuration
export const MODAL_CONFIG = {
  [MODAL_TYPES.DOWNPAYMENT]: {
    title: 'Select your down payment amount',
    inputLabel: 'Down Payment',
    inputPrefix: '₹',
    placeholder: 'Enter Amount',
  },
  [MODAL_TYPES.TENURE]: {
    title: 'Select your loan tenure',
    options: FINANCE_CONSTANTS.TENURE_OPTIONS,
  },
  [MODAL_TYPES.INTEREST]: {
    title: 'Select loan rate of interest',
    inputLabel: 'Other dealer interest (optional)',
    inputPrefix: '%',
    placeholder: 'Other dealer interest (optional)',
  },
  BUTTON_TEXT: 'Update',
} as const;

// Validation configuration
export const VALIDATION_CONFIG = {
  downPayment: {
    minPercentage: FINANCE_CONSTANTS.MIN_DOWN_PAYMENT_PERCENTAGE,
    maxPercentage: FINANCE_CONSTANTS.MAX_DOWN_PAYMENT_PERCENTAGE,
    messages: {
      invalidAmount: VALIDATION_MESSAGES.INVALID_AMOUNT,
      invalidNumber: VALIDATION_MESSAGES.INVALID_NUMBER,
      invalidFormat: VALIDATION_MESSAGES.INVALID_FORMAT,
      exceedsCarValue: VALIDATION_MESSAGES.DOWNPAYMENT_EXCEEDS_CAR_VALUE,
    },
  },
  interest: {
    min: FINANCE_CONSTANTS.MIN_INTEREST_RATE,
    max: FINANCE_CONSTANTS.MAX_INTEREST_RATE,
    messages: {
      enterInterest: VALIDATION_MESSAGES.ENTER_INTEREST,
      invalidFormat: VALIDATION_MESSAGES.INVALID_FORMAT,
      invalidDecimal: VALIDATION_MESSAGES.INVALID_DECIMAL,
      maxDecimalPlaces: VALIDATION_MESSAGES.MAX_DECIMAL_PLACES,
      completeDecimal: VALIDATION_MESSAGES.COMPLETE_DECIMAL,
      minInterest: VALIDATION_MESSAGES.MIN_INTEREST,
      maxInterest: VALIDATION_MESSAGES.MAX_INTEREST,
    },
  },
} as const;

// Slider style configuration
export const SLIDER_STYLE_CONFIG = {
  trackColor: 'rgb(240, 240, 246)',
  fillColor: 'rgb(140, 233, 154)',
  thumbBackground: '#18183a',
  thumbIcon: '/icons/thumb.svg',
} as const;
